import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { ServiceGridItemObject } from '@it2go/types';

@Injectable()
export class ServicesPageStore extends ComponentStoreV2Factory {
    public services = computed(() => {
        const grid = this.data.getServices();
        if (!grid) {
            return null;
        }

        const items = (grid.items || [])
            .map((it: ServiceGridItemObject) => {
                const canRead = this.isAllowedForService('administration.read', it.id)();
                const canDelete = this.isAllowedForService('service.delete', it.id)();

                return {
                    ...it,
                    __hideDetail: !canRead,
                    __hideDelete: !canDelete,
                };
            })
        ;

        return {
            ...grid,
            items,
        };
    });
}
